@if(showCopyright) {
&copy; {{ currentYear }} {{ brandName() }}. All rights reserved.
}
<app-report-issue></app-report-issue>
